import React from 'react';
import { clampPercent, titleCase } from '../utils/format';
import './resumePanel.css';

/**
 * The dashboard's "pick up where you left off" panel.
 * Renders only fields the dashboard API actually returns — see spec §5.0.
 */
export default function ResumePanel({ course, onContinue, onViewOutline }) {
  if (!course) return null;
  const pct = clampPercent(course.completionPercentage);

  return (
    <section className="resume-panel" aria-label="Continue learning">
      <div className="resume-panel-body">
        <p className="resume-panel-label">Continue learning</p>

        <div className="resume-panel-heading">
          <h2 className="resume-panel-title">{course.name}</h2>
          {course.tag && <span className="resume-panel-subject">{titleCase(course.tag)}</span>}
        </div>

        {course.nextUpSection && (
          <p className="resume-panel-next">
            Next up: <span>{course.nextUpSection}</span>
          </p>
        )}

        <div className="resume-panel-progress">
          <div className="resume-panel-track">
            <div className="resume-panel-fill" style={{ width: `${pct}%` }} />
          </div>
          <span className="resume-panel-pct">{pct}%</span>
        </div>
      </div>

      <div className="resume-panel-actions">
        <button type="button" className="resume-panel-secondary" onClick={onViewOutline}>View outline</button>
        <button type="button" className="resume-panel-primary" onClick={onContinue}>Continue lesson</button>
      </div>
    </section>
  );
}
